const ClosingStock = () => import('./closing.vue');

export default [
    {
        path: '/closing/stock',
        component: ClosingStock
    },
]